import { Container as MaterialContainer, SxProps, useTheme } from '@mui/material';
import React, { FC, PropsWithChildren } from 'react';

import { LibroTheme, Size } from '../../theme/types';

export interface ContainerProps {
  className?: string;
  disableGutters?: boolean;
  size?: Size;
  sx?: SxProps<LibroTheme>;
}

export const maxWidth = (size: Size): false | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | undefined => {
  switch (size) {
    case Size.Large:
      return 'xl';
    case Size.Small:
      return 'md';
    case Size.XSmall:
      return 'sm';
    default:
      return 'lg';
  }
};

/**
 * Centers the content and defines a max width
 */
const Container: FC<PropsWithChildren<ContainerProps>> = ({ children, ...props }) => {
  const theme = useTheme<LibroTheme>();
  const { size, ...containerProps } = props;

  return (
    <MaterialContainer
      data-testid="container-root"
      maxWidth={maxWidth(size ?? theme.containerDefaultSize ?? Size.Large)}
      {...containerProps}
    >
      {children}
    </MaterialContainer>
  );
};

export default Container;
